import React, { useEffect } from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import Pagination from '~components/atoms/Pagination';

const ProjectManagementTablePaginator = () => {
    const isLoading = useAppSelector(state => state.project.loadings.getProjectListing);
    const { index, maxIndex } = useAppSelector(state => state.project.projectListing);

    const dispatch = useAppDispatch();

    const setIndex = (newIndex: number) => {
        if (isLoading) return;

        dispatch(combinedActions.projectSetProjectListingIndex({ index: newIndex }));
    };

    useEffect(() => {
        if (index > maxIndex) {
            setIndex(0);
        }
    }, [maxIndex]);

    const handleOnPrev = () => {
        if (index > 0) setIndex(index - 1);
    };
    const handleOnNext = () => {
        if (index < maxIndex) setIndex(index + 1);
    };
    const handleOnFirst = () => setIndex(0);
    const handleOnLast = () => setIndex(maxIndex);

    return (
        <Pagination
            currentPage={index}
            maxPage={maxIndex}
            onPrev={handleOnPrev}
            onNext={handleOnNext}
            onFirst={handleOnFirst}
            onLast={handleOnLast}
        />
    );
};

export default ProjectManagementTablePaginator;
